import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import {
    renderField,
    required,
    renderTextArea,
} from "../../../../utils/formValidations.js";
import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";

class GcpDnsProviderFormTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentProvider: {},
        };
        this.submitApi = this.submitApi.bind(this);
        this.cancelButton = this.cancelButton.bind(this);

    }

    componentDidMount() {
        if (this.props.current_provider) {
            this.props.initialize({
                dns_provider_config_name: this.props.current_provider.dns_provider_config_name,
                dns_provider_name: this.props.current_provider.dns_provider_name,
                gcp_project: this.props.current_provider.gcp_project,
                gcp_credentials: JSON.stringify(this.props.current_provider.gcp_credentials, null, 2),
            });
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
            this.props.initialize({
                dns_provider_config_name: nextProps.current_provider.dns_provider_config_name,
                dns_provider_name: nextProps.current_provider.dns_provider_name,
                gcp_project: nextProps.current_provider.gcp_project,
                gcp_credentials: JSON.stringify(nextProps.current_provider.gcp_credentials, null, 2),
            });
        }
    }


    cancelButton() {
        this.props.cancel_button(userData)
    }


    submitApi(userData) {
        userData.dns_provider_name = "gcp"
        this.props.submit_api(userData)

    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="dns_provider_config_name" className="requiredasterisk">Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="dns_provider_config_name"
                                    id="dns_provider_config_name"
                                    component={renderField}
                                    validate={required}
                                    placeholder="Example Gcp Config"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_project" className="requiredasterisk">Project</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_project"
                                    id="gcp_project"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="gcp_credentials" className="requiredasterisk">Credentials (JSON)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="gcp_credentials"
                                    id="gcp_credentials"
                                    placeholder='{"name":"value"}'
                                    component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="button" size="sm"
                            className="cancel-button"
                            color="basic" onClick={() => this.props.cancel_button()}>{ this.props.wizard ? 'Previous' : 'Cancel'}</Button>
                        <Button type="submit"
                            className="submit-button"
                            size="sm" color="primary">{ this.props.wizard ? 'Finish' : 'Submit'}</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}


GcpDnsProviderFormTemplate.propTypes = {
    current_provider: Proptypes.object,
    submit_api: Proptypes.func.isRequired,
    handleSubmit: Proptypes.func,
    cancel_button: Proptypes.func,
};


let GcpDnsProviderFormWithRouter = withRouter(GcpDnsProviderFormTemplate);

let GcpDnsProviderForm = connect(state => {

    return {
        dns_provider_configs: state.dns_provider.dns_provider_configs,
    }
},

    dispatch =>
    ({

    }))(GcpDnsProviderFormWithRouter);

export default reduxForm({
    form: "DnsProviderForm",
})(GcpDnsProviderForm);
